<template>
    <div id="header">
        <header class="py-4">
            <div class="container-xxl">
                <div class="d-flex flex-wrap align-items-streach justify-content-center justify-content-lg-start">
                    <div id="logo">
                        <a :href="basePath">
                            <img
                                v-if="config?.main?.show_logo === true"
                                class="me-4"
                                src="@/assets/images/logo.png"
                            />
                            <span v-else class="me-4" style="display: inline-block; width: 65px;"></span>
                        </a>
                    </div>

                    <span class="text-white d-none d-xl-inline" style="min-width: 180px;">
                        <span v-if="$store.getters['users/isAuth']">
                            <font-awesome-icon :icon="['fas', 'circle-user']" />
                            {{ $t('app.welcome') }}, <span class="fw-medium">{{ user.name }}</span>!
                        </span>
                        <span v-else style="visibility: hidden;">X</span>
                    </span>

                    <div class="flex-fill"></div>

                    <ul class="nav">
                        <li class="nav-item">
                            <app-lang-switcher />
                        </li>
                        <li class="nav-item">
                            <app-currencies-switcher />
                        </li>
                        <li class="nav-item">
                            <a
                                v-if="!$store.getters['users/isAuth']"
                                @click="openLoginModal"
                                class="nav-link px-2 header-btn text-white">
                                {{ $t('app.login') }} <font-awesome-icon :icon="['fas', 'right-to-bracket']" />
                            </a>
                            <a
                                v-else
                                @click="logout"
                                class="nav-link px-2 header-btn text-white">
                                {{ $t('app.logout') }} <font-awesome-icon :icon="['fas', 'right-to-bracket']" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="d-flex justify-content-center">
                <app-nav v-if="config?.main?.show_home_button !== false" />
            </div>
        </header>

        <div class="modal-container">
            <login-modal ref="loginModal" />
        </div>

    </div>
</template>

<script>
import AppNav from 'components/app/AppNav.vue'
import AppLangSwitcher from 'components/app/AppLangSwitcher.vue'
import AppCurrenciesSwitcher from 'components/app/AppCurrenciesSwitcher.vue'
import LoginModal from 'modules/login/LoginModal.vue'
import { mapState } from 'vuex'

export default {
    name: 'AppHeader',
    components: {
        AppNav,
        AppLangSwitcher,
        LoginModal,
        AppCurrenciesSwitcher
    },
    computed: {
        ...mapState({
            user: state => state.users.user,
            config: state => state.config
        }),
        basePath() {
            return process.env.VUE_APP_BASE_URL;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('users/logout', this.$router)
        },
        openLoginModal() {
            this.$refs.loginModal.open();
        }
    }
}
</script>
